module.exports = __webpack_public_path__ + "img/partner-industry-problem-icon.8f057d09.png";